import { useCallback, useEffect, useMemo, useState } from 'react';
import c from 'classnames';

import { jsonParse, jsonStringify } from '@lyearn/core/utils/json';
import { useNodePerformanceContext, useReactNodeView } from '@lyearn/lygo-core';
import { Checkbox, Stack } from '@lyearn/ui';

import { NODE_NAME } from '../consts';
import { checkboxStyles, checkedTextStyles } from './styles';

const CheckListItemReadOnly = () => {
  const { node } = useReactNodeView();
  const { setNodePerformance, getNodePerformance } = useNodePerformanceContext();

  const [isChecked, setIsChecked] = useState(false);

  const nodeId = node?.attrs?.id;

  const defaultProgress = useMemo(() => {
    if (nodeId) {
      const parsedMeta = jsonParse<{ checked?: boolean }>(getNodePerformance?.(nodeId)?.meta || '');
      if (parsedMeta.data?.checked) return parsedMeta.data?.checked;
    }
    return false;
  }, [nodeId, getNodePerformance]);

  useEffect(() => {
    setIsChecked(defaultProgress);
  }, [defaultProgress]);

  const onCheckChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;
      setIsChecked(checked);

      if (nodeId) {
        setNodePerformance?.({
          id: nodeId,
          blockType: NODE_NAME,
          meta: jsonStringify({
            checked: checked,
          }).data,
        });
      }
    },
    [nodeId, setNodePerformance],
  );

  return (
    <Stack className={c({ [`${checkedTextStyles}`]: isChecked })}>
      <Checkbox
        checked={isChecked}
        className={c(checkboxStyles, 'mt-20 self-start me-16')}
        variant="circle"
        onChange={onCheckChange}
      />
    </Stack>
  );
};

export default CheckListItemReadOnly;
